import React from 'react';
import { Reveal } from './Reveal';
const stats: [string, string][] = [['10', 'Komplette Bände'], ['600', 'Seiten Unterrichtsmaterial'], ['80', 'Unterrichtseinheiten'], ['100 %', 'Für alle Bundesländer']];
export function StatsBar() {
  return <section className="border-y border-brand-line bg-brand-alt px-5 py-12" data-id="element-148" data-mp="1odhxt3nc7x1t">
      <Reveal className="mx-auto grid max-w-[1100px] grid-cols-2 gap-8 text-center md:grid-cols-4" data-id="element-149" data-mp="1jbsk1g8qd5a1">
        {stats.map(([value, label]) => <div key={label} className="flex flex-col items-center" data-id="element-150" data-mp="19mr6rxtkl1zr">
            <span className="font-display text-4xl font-extrabold leading-none text-brand-navy md:text-5xl" data-id="element-151" data-mp="19l7m7v0vs4s6">
              {value}
            </span>
            <span className="mt-3 text-[11px] font-bold uppercase leading-snug tracking-[0.12em] text-brand-gray" data-id="element-152" data-mp="10mlyllgjxzkj">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}